import { BotAccountErrorsPanel } from '@/components/admin/BotAccountErrorsPanel';

export default function BotAccountErrorsPage() {
  return <BotAccountErrorsPanel />;
}
